import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { EventDetailHeader } from '~/features/events/components/event-detail-header'
import { EventRequestsPanel } from '~/features/events/components/event-requests-panel'
import { ProfileLinkPrompt } from '~/features/profile-link/components/profile-link-prompt'
import * as m from '~/paraglide/messages'
import { Button } from '~/shared/ui/button'

export const Route = createFileRoute('/dashboard/events/$eventId/requests')({
  component: EventRequests,
})

function EventRequests() {
  const { eventId } = Route.useParams()
  return (
    <div className="w-full max-w-5xl space-y-6">
      <Button asChild variant="ghost" size="sm" className="w-fit">
        <Link to="/dashboard/events/$eventId" params={{ eventId }}>
          <ArrowLeft className="h-4 w-4" />
          {m.backToEvent()}
        </Link>
      </Button>
      <EventDetailHeader eventId={eventId} />
      <EventRequestsPanel eventId={eventId} />
      <ProfileLinkPrompt />
    </div>
  )
}
